/** @param {string} ymd yyyy-MM-dd */
export function ymdToDdMmYyyy(ymd) {
    if (!ymd || typeof ymd !== "string") return null;
    const parts = ymd.trim().split("-");
    if (parts.length !== 3) return null;
    const y = Number(parts[0]);
    const m = Number(parts[1]);
    const day = Number(parts[2]);
    if (!y || !m || !day) return null;
    const pad = (n) => String(n).padStart(2, "0");
    return `${pad(day)}-${pad(m)}-${y}`;
}

export function normalizeUnavailableDatesList(raw) {
    if (raw == null) return [];
    let arr = raw;
    if (typeof raw === "string") {
        try {
            arr = JSON.parse(raw);
        } catch {
            return [];
        }
    }
    if (!Array.isArray(arr)) return [];
    const pad = (n) => String(n).padStart(2, "0");
    const out = [];
    for (const x of arr) {
        const s = String(x).trim();
        if (/^\d{1,2}-\d{1,2}-\d{4}$/.test(s)) {
            const [d, m, y] = s.split("-").map((n) => Number(n));
            if (d >= 1 && d <= 31 && m >= 1 && m <= 12) {
                out.push(`${pad(d)}-${pad(m)}-${y}`);
            }
        }
    }
    return [...new Set(out)].sort();
}

/** @param {Date} d local */
export function dateToYmdLocal(d) {
    if (!d || Number.isNaN(d.getTime())) return "";
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function isYmdUnavailable(ymd, unavailableDdMmYyyy) {
    const dd = ymdToDdMmYyyy(ymd);
    if (!dd) return false;
    const set = new Set(normalizeUnavailableDatesList(unavailableDdMmYyyy));
    return set.has(dd);
}

export function isDateObjUnavailable(date, unavailableDdMmYyyy) {
    return isYmdUnavailable(dateToYmdLocal(date), unavailableDdMmYyyy);
}

function eachYmdInRangeInclusive(startYmd, endYmd) {
    const out = [];
    const [sy, sm, sd] = startYmd.split("-").map(Number);
    const [ey, em, ed] = endYmd.split("-").map(Number);
    let d = new Date(sy, sm - 1, sd);
    const end = new Date(ey, em - 1, ed);
    if (d > end) [d, end] = [end, d];
    const cursor = new Date(d);
    while (cursor <= end) {
        out.push(dateToYmdLocal(cursor));
        cursor.setDate(cursor.getDate() + 1);
    }
    return out;
}

/** @returns {{ ymd: string, label: string } | null} */
export function firstUnavailableInRange(startYmd, endYmd, unavailableDdMmYyyy) {
    const set = new Set(normalizeUnavailableDatesList(unavailableDdMmYyyy));
    for (const ymd of eachYmdInRangeInclusive(startYmd, endYmd)) {
        const dd = ymdToDdMmYyyy(ymd);
        if (dd && set.has(dd)) {
            const [y, m, day] = ymd.split("-").map(Number);
            const months = [
                "January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December",
            ];
            let ord;
            if (day >= 11 && day <= 13) ord = `${day}th`;
            else if (day % 10 === 1) ord = `${day}st`;
            else if (day % 10 === 2) ord = `${day}nd`;
            else if (day % 10 === 3) ord = `${day}rd`;
            else ord = `${day}th`;
            return { ymd, label: `${ord} ${months[m - 1]}` };
        }
    }
    return null;
}

/** DD-MM-YYYY -> Date local noon */
export function ddMmYyyyToDate(s) {
    const [d, m, y] = String(s).split("-").map(Number);
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d, 12, 0, 0, 0);
}
